import { useState, useCallback } from 'react';

export interface ModalsState {
    activeModal: string | null;
    selectedWebcam: any;
    showCitySelector: boolean;
    showSettings: boolean;
    showProfile: boolean;
    showFullscreenSummary: boolean;
    showDirectSettings: boolean;
    showFullscreenContest: boolean;
    showRatingModal: boolean;
    showContestGifts: boolean;
    showFlowers: boolean;
    showNetworking: boolean;
    showNetworkingBanner: boolean;
    showNotifications: boolean;
    showGiftSubscription: boolean;
    showActivateGift: boolean;
    activateGiftCode: string | null;
    networkingInitialTab: "feed" | "contacts" | "requests" | "profile";
}

export const useModalsState = () => {
    const [activeModal, setActiveModal] = useState<string | null>(null);
    const [selectedWebcam, setSelectedWebcam] = useState<any>(null);
    const [showCitySelector, setShowCitySelector] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [showFullscreenSummary, setShowFullscreenSummary] = useState(false);
    const [showDirectSettings, setShowDirectSettings] = useState(false);
    const [showFullscreenContest, setShowFullscreenContest] = useState(false);
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [showContestGifts, setShowContestGifts] = useState(false);
    const [showFlowers, setShowFlowers] = useState(false);
    const [showNetworking, setShowNetworking] = useState(false);
    const [showNetworkingBanner, setShowNetworkingBanner] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showGiftSubscription, setShowGiftSubscription] = useState(false);
    const [showActivateGift, setShowActivateGift] = useState(false);
    const [activateGiftCode, setActivateGiftCode] = useState<string | null>(null);
    const [networkingInitialTab, setNetworkingInitialTab] = useState<"feed" | "contacts" | "requests" | "profile">("feed");

    const closeAllModals = useCallback(() => {
        setActiveModal(null);
        setSelectedWebcam(null);
        setShowCitySelector(false);
        setShowSettings(false);
        setShowProfile(false);
        setShowFullscreenSummary(false);
        setShowDirectSettings(false);
        setShowFullscreenContest(false);
        setShowRatingModal(false);
        setShowContestGifts(false);
        setShowFlowers(false);
        setShowNetworking(false);
        setShowNetworkingBanner(false);
        setShowNotifications(false);
        setShowActivateGift(false);
        setActivateGiftCode(null);
    }, []);

    return {
        // Состояния
        activeModal,
        selectedWebcam,
        showCitySelector,
        showSettings,
        showProfile,
        showFullscreenSummary,
        showDirectSettings,
        showFullscreenContest,
        showRatingModal,
        showContestGifts,
        showFlowers,
        showNetworking,
        showNetworkingBanner,
        showNotifications,
        showGiftSubscription,
        showActivateGift,
        activateGiftCode,
        networkingInitialTab,

        // Сеттеры
        setActiveModal,
        setSelectedWebcam,
        setShowCitySelector,
        setShowSettings,
        setShowProfile,
        setShowFullscreenSummary,
        setShowDirectSettings,
        setShowFullscreenContest,
        setShowRatingModal,
        setShowContestGifts,
        setShowFlowers,
        setShowNetworking,
        setShowNetworkingBanner,
        setShowNotifications,
        setShowGiftSubscription,
        setShowActivateGift,
        setActivateGiftCode,
        setNetworkingInitialTab,
        // Утилиты
        closeAllModals,
    };
};